import React from 'react';
import { PageSources } from './PageSources';
interface PageHeaderProps {
  title: string;
  lede: React.ReactNode;
  /** Data badges — rendered in the page's bottom Sources block, not in the header. */
  children?: React.ReactNode;
}
export function PageHeader({
  title,
  lede,
  children
}: PageHeaderProps) {
  return <header className="border-b border-line" data-id="element-643" data-mp="3mgu6qjg65ikk">
      <div className="mx-auto max-w-[1400px] px-5 pb-8 pt-10 md:px-8 md:pt-14" data-id="element-644" data-mp="3mdodqt4f5wjk">
        <h1 className="font-serif text-4xl leading-[1.05] text-ink md:text-[3.25rem]" data-id="element-645" data-mp="2ynu56nr4uu54">{title}</h1>
        <p className="mt-4 max-w-2xl text-[15px] leading-relaxed text-muted md:text-base" data-id="element-646" data-mp="2toqyyzzf2hvk">{lede}</p>
      </div>
      {children && <PageSources data-id="element-647" data-mp="33p1fouknu7fh">{children}</PageSources>}
    </header>;
}